"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exportMemberOrders = exportMemberOrders;
exports.getMemberOrders = getMemberOrders;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
// 获取会员订单列表
function getMemberOrders(query) {
  return (0, _requestAuth.default)({
    url: '/xyUsers/vipOrderInfo',
    method: 'get',
    params: query
  });
}

// 导出会员订单列表
function exportMemberOrders(query) {
  return (0, _requestAuth.default)({
    url: '/xyUsers/exportVipOrderInfo',
    method: 'get',
    params: query
  });
}